import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavigationMenu, NavigationMenuList, navigationMenuTriggerStyle } from './ui/navigation-menu';
import { cn } from '../lib/utils';
import { Button } from './ui/button';
import GarageDrawer from './GarageDrawer';

export default function AppHeader() {
  const location = useLocation();
  const [garageOpen, setGarageOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-16 items-center">
          {/* Logo and Nav Row */}
          <div className="flex items-center justify-between w-full">
            <Link to="/" className="flex items-center gap-2 font-bold text-xl text-foreground">
              <span className="text-brand-red">LINDUSKA</span>
              <span className="text-foreground">MOTO CO.</span>
            </Link>

            {/* Desktop Navigation + Garage button (shown on md+) */}
            <div className="hidden md:flex items-center gap-2">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setGarageOpen(true)}
              >
                Garage
              </Button>
              <NavigationMenu>
                <NavigationMenuList>
                  <li>
                    <Link
                      to="/"
                      className={cn(
                        navigationMenuTriggerStyle(),
                        isActive('/') && 'bg-muted text-foreground'
                      )}
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/shop"
                      className={cn(
                        navigationMenuTriggerStyle(),
                        isActive('/shop') && 'bg-muted text-foreground'
                      )}
                    >
                      Shop
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/motorcycles"
                      className={cn(
                        navigationMenuTriggerStyle(),
                        isActive('/motorcycles') && 'bg-muted text-foreground'
                      )}
                    >
                      Motorcycles
                    </Link>
                  </li>
                </NavigationMenuList>
              </NavigationMenu>
            </div>

            {/* Mobile Garage button (shown only on small screens) */}
            <div className="flex md:hidden">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setGarageOpen(true)}
              />
            </div>
          </div>
        </div>
      </header>

      {/* Garage Drawer */}
      {garageOpen && (
        <div className="fixed inset-0 z-50 md:flex hidden items-start justify-end">
          <div
            className="fixed inset-0 bg-black/50"
            onClick={() => setGarageOpen(false)}
          />
          <div className="h-full w-[380px] bg-background shadow-lg">
            <GarageDrawer onClose={() => setGarageOpen(false)} />
          </div>
        </div>
      )}
    </>
  );
}
